var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgParkingCarReduced({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 320,
    height: 320,
    viewBox: "30 30 260 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "parkingCarReduced_svg__a",
    points: ".001 .879 73.056 .879 73.056 87.461 .001 87.461"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M160.441 275.705c-64.147 0-116.152-52.004-116.152-116.15 0-64.146 52.005-116.15 116.152-116.15 64.147 0 116.152 52.004 116.152 116.15 0 64.146-52.005 116.15-116.152 116.15z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FEFEFE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.905 80.286l-54.002-45.72a6.632 6.632 0 00-8.562 0l-53.998 45.72c-2.789 2.359-3.14 6.546-.773 9.335a6.628 6.628 0 009.34.777l.86-.732v52.654a4.141 4.141 0 004.146 4.137h89.417a4.137 4.137 0 004.141-4.137V89.666l.869.732a6.615 6.615 0 009.34-.777c2.363-2.789 2.01-6.976-.778-9.335M110.56 249.9H54.5c-4.672 0-8.499-3.821-8.499-8.498v-69.586c0-4.677 3.827-8.498 8.499-8.498h56.06c4.671 0 8.497 3.821 8.497 8.498v69.586c0 4.677-3.826 8.499-8.498 8.499"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "currentColor",
    fontFamily: "Lato-Regular, Lato",
    fontSize: 77.793,
    transform: "translate(46 32)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 13.214,
    y: 184.978
  }, "P")), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M188.273 246.33h-56.06c-4.671 0-8.497-3.823-8.497-8.5v-69.585c0-4.677 3.826-8.499 8.498-8.499h56.06c4.671 0 8.498 3.822 8.498 8.499v69.586c0 4.676-3.827 8.498-8.499 8.498",
    opacity: 0.505
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(201.429 158.868)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parkingCarReduced_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parkingCarReduced_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M64.56 87.461H8.5C3.828 87.461 0 83.64 0 78.963V9.377C.001 4.7 3.828.879 8.5.879h56.06c4.671 0 8.497 3.821 8.497 8.498v69.586c0 4.677-3.826 8.498-8.498 8.498",
    mask: "url(#parkingCarReduced_svg__b)"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "currentColor",
    fontFamily: "Lato-Regular, Lato",
    fontSize: 77.793,
    transform: "translate(46 32)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 168.643,
    y: 181.407
  }, "P")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(116.571 111.582)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.394,
    x2: 86.949,
    y1: 36.513,
    y2: 146.835,
    stroke: "currentColor",
    strokeWidth: 7.571
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.947,
    x2: 0.392,
    y1: 36.513,
    y2: 146.835,
    stroke: "currentColor",
    strokeWidth: 7.571
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M48.395.418h-9.6c-5.17 0-9.366 4.197-9.366 9.371v28.115H57.77V9.789c0-5.174-4.196-9.37-9.376-9.37"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingCarReduced);
export default __webpack_public_path__ + "static/media/parkingCarReduced.070ef3fb.svg";
export { ForwardRef as ReactComponent };